import React from 'react'
import LeftSideOfForm from './LeftSideOfForm'
import RightSideOfForm from './RightSideOfForm'
export default function CreateTournamentForm() {
    return (
        <div className="create-tournament-form">
         <LeftSideOfForm/>
         <RightSideOfForm/>   
        </div>
    )
}
